import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.30127 10.5V20",
		stroke: "#323232",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.30127 10.5001L10.637 4.6305C10.7339 4.38702 10.9225 4.19131 11.1622 4.08546C11.4019 3.97961 11.6736 3.97208 11.9188 4.0645L12.558 4.30541C13.1287 4.52048 13.6202 4.90437 13.9672 5.4059C14.3141 5.90743 14.5 6.50279 14.5 7.11264V10.5H17.4988C17.8787 10.5 18.2536 10.5866 18.5951 10.7532C18.9365 10.9198 19.2355 11.162 19.4693 11.4614C19.7031 11.7609 19.8656 12.1097 19.9444 12.4814C20.0232 12.853 20.0163 13.2377 19.9241 13.6063L18.7991 18.1063C18.6639 18.6472 18.3517 19.1274 17.9123 19.4705C17.4728 19.8136 16.9313 20 16.3738 20H5.5C5.10218 20 4.72064 19.8419 4.43934 19.5606C4.15804 19.2793 4 18.8978 4 18.5V12C4 11.6022 4.15804 11.2206 4.43934 10.9393C4.72064 10.658 5.10218 10.5 5.5 10.5L8.30127 10.5001Z",
		stroke: "#323232",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgThumbUp);
export default ForwardRef;
